module.exports = __webpack_public_path__ + "static/media/sun.4db24c0e.svg";